import React from "react";
import { useNavigate } from "react-router-dom";

const cardBase =
  "rounded-xl p-5 flex flex-col gap-3 border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] hover:shadow-[0_0_20px_#00ff9044] transition-shadow";

const QuickManagerActions = () => {
  const navigate = useNavigate();

  const actionBtn = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "100%",
    padding: "10px 14px",
    background: "transparent",
    border: "0.5px solid #222",
    borderRadius: 8,
    color: "#ccc",
    fontSize: 13,
    cursor: "pointer",
    textAlign: "left",
  };

  return (
    <div className={cardBase}>
      <div className="flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest">Quick Actions</span>
        <span className="text-2xl">⚡</span>
      </div>

      <div className="flex flex-col gap-2">
        <button onClick={() => navigate("/messenger/learning/team")} style={actionBtn}>
          🎓 Team Learning &amp; Development
        </button>
        <button onClick={() => navigate("/manager/team-attendance")} style={actionBtn}>
          📅 Team Attendance
        </button>
        <button onClick={() => navigate("/manager/team-leave")} style={actionBtn}>
          🗓️ Team Leave Approvals
        </button>
        <button onClick={() => navigate("/messenger/announcements")} style={actionBtn}>
          📣 Announcements
        </button>
        <button onClick={() => navigate("/messenger/expenses?tab=team")} style={actionBtn}>
          🧾 Team Expenses
        </button>
      </div>
    </div>
  );
};

export default QuickManagerActions;
